import axios from "@axios";
import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchUser(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(``, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post("/apps/user/users", { user: userData })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/", userData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    migrateUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/migrate", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    migrateProducts(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/migrate/products", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    migrateDescription(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/migrate/description", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    symbolicLink(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/symboliclink", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    copyFile(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/copyFile", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updatePermission(ctx, userData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/store-manager-permission", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    syncDatabase(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/sync-database")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    }
  },
};
